const Default = () => import(/* webpackChunkName: "index" */ './Default');
const Head = () => import(/* webpackChunkName: "index" */ './Head');
const Manager = () => import(/* webpackChunkName: "index" */ './Manager');
const PatentDirector = () => import(/* webpackChunkName: "index" */ './PatentDirector');
const HeadSubFund = () => import(/* webpackChunkName: "index" */ './HeadSubFund/Fund');

// 科研秘书角色首页
const Secretary = () => import(/* webpackChunkName: "index" */ './Secretary');

export default {
  routes: [
    {
      path: '/index/default',
      name: 'index_default',
      component: Default
    }, {
      path: '/index/head',
      name: 'index_head',
      component: Head
    }, {
      path: '/index/PatentDirector',
      name: 'index_PatentDirector',
      component: PatentDirector
    }, {
      path: '/index/manager',
      name: 'index_manager',
      component: Manager
    }, {
      path: '/index/HeadSubFund/Fund',
      name: 'index_headSubFund_fund',
      component: HeadSubFund
    }, {
      path: '/index/secretary',
      name: 'index_secretary',
      component: Secretary
    }
  ]
}
